import { render, staticRenderFns } from "./shared-story-filter-app.vue?vue&type=template&id=0bd8dc56&"
import script from "./shared-story-filter-app.vue?vue&type=script&lang=js&"
export * from "./shared-story-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports